import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const getCanadaPayrollData = async (from, to) => {
    try {
        let url = `${BaseUrl}CanadaPayrollMasterfile/get-payrollHrs-latest-data?fromDate=${from}&toDate=${to}`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const getCanadaPayrollMasterfileData = async (from, to) => {
    try {
        let url = `${BaseUrl}CanadaPayrollMasterfile/get-masterfile-data?fromDate=${from}&toDate=${to}`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const getCanadaMasterfileData = async () => {
    try {
        let url = `${BaseUrl}CanadaPayrollMasterfile/get-masterfile-data`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            return [sample.MasterData, sample.UnmatchedData];
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {

    }
}
export const getUnmatchedListData = async () => {
    try {
        const url = `${BaseUrl}CanadaPayrollMasterfile/CanadaLookupData`;
        const res = await axios.post(url, JsonConfig);

        if (res.data.statusCode === 200) {
            const unmatchedList = JSON.parse(res.data.payload);
            return unmatchedList;
        } else {
            console.error("Error fetching data:", res.data.message);
            return null;
        }
    } catch (error) {
        console.error("API call failed:", error);
        return null;
    }
};
export const updateCanadaMFRow = async (props) => {
    try {
        let data = props;
        let url = `${BaseUrl}CanadaPayrollMasterfile/update-canada-payrollHrs-data`
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}
export const downloadCanadaMSXL = async (props) => {
    try {
        const temp = props;
        if (temp.length > 0) {
            let sampleList = temp;
            let loopedList = [];
            loopedList.length = 0;
            let len = sampleList.length;

            const sanitizeCellValue = (value) => {
                if (typeof value === "string" && /^[=+\-@]/.test(value)) {
                    return `'${value}`; // Prefix with an apostrophe
                }
                return value;
            };

            let i;
            loopedList.push([
                'Portal', 'Client', 'Payroll Name', 'Status', 'RT', 'OT', 'DT', 'Other Hours',
                'Week Start Date', 'Week End Date', 'Download Date'
            ].map(sanitizeCellValue));

            for (i = 0; i < len; i++) {
                loopedList.push([
                    sanitizeCellValue(sampleList[i].Client_Type),
                    sanitizeCellValue(sampleList[i].Client),
                    sanitizeCellValue(sampleList[i].Payroll_Name),
                    sanitizeCellValue(sampleList[i].Status),
                    sanitizeCellValue(sampleList[i].RT),
                    sanitizeCellValue(sampleList[i].OT),
                    sanitizeCellValue(sampleList[i].DT),
                    sanitizeCellValue(sampleList[i].Other_Hours),
                    sanitizeCellValue(sampleList[i].WeekStartDate),
                    sanitizeCellValue(sampleList[i].Weekend),
                    sanitizeCellValue(sampleList[i].DownloadDate)
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'Consolidated data.csv');
                });

            return "downloaded"
        }
        else { return null }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}
export const downloadCanadaMasterfileXL = async (props, data, val) => {
    try {
        const temp = props;
        const value = val;
        const unmatchedData = data;

        const sanitizeCellValue = (value) => {
            if (typeof value === "string" && /^[=+\-@]/.test(value)) {
                return `'${value}`; 
            }
            return value;
        };

        const sortSampleList = (list, fields) => {
            return list.sort((a, b) => {
                for (let field of fields) {
                    const valA = a[field]?.toString().toLowerCase() || "";
                    const valB = b[field]?.toString().toLowerCase() || "";
                    if (valA < valB) return -1;
                    if (valA > valB) return 1;
                }
                return 0;
            });
        };

        if (value === 'one') {
            if (temp.length > 0) {
                let sampleList = sortSampleList(temp, [  "Client","RateType","EmployeeName"]);
                let loopedList = [];

                loopedList.push([
                    'CoCode', 'File Number', 'Employee Name',
                    'Province', 'Client', 'Hire Date', 'Rate Type', 'Payrate',
                    'Pay Frequency', 'FLSA', 'Term Date',
                    'RT', 'OT', 'DT', 'Status', 'Salaried', 'Weekend',
                ].map(sanitizeCellValue));

                sampleList.forEach(item => {
                    loopedList.push([
                        sanitizeCellValue(item.CoCode),
                        sanitizeCellValue(item.FileNo),
                        sanitizeCellValue(item.EmployeeName),
                        sanitizeCellValue(item.Province),
                        sanitizeCellValue(item.Client),
                        sanitizeCellValue(item.HireDate),
                        sanitizeCellValue(item.RateType),
                        sanitizeCellValue(item.Payrate),
                        sanitizeCellValue(item.PayFrequency),
                        sanitizeCellValue(item.FLSA),
                        sanitizeCellValue(item.TermDate),
                        sanitizeCellValue(item.RT),
                        sanitizeCellValue(item.OT),
                        sanitizeCellValue(item.DT),
                        sanitizeCellValue(item.Status),
                        sanitizeCellValue(item.Salaried),
                        sanitizeCellValue(item.Weekend)
                    ]);
                });

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                loopedList.forEach(row => worksheet.addRow(row));

                await workbook.csv.writeBuffer().then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'canadamasterfile.csv');
                });

                return "downloaded";
            } else {
                return null;
            }
        }

        if (value === 'two') {
            if (unmatchedData.length > 0) {
                let sampleList = sortSampleList(unmatchedData, ["Client"]);
                let loopedList = [];

                loopedList.push(['Client', 'ActiveListName', 'PayrollName', 'PositionID'
                ].map(sanitizeCellValue));

                sampleList.forEach(item => {
                    loopedList.push([
                        sanitizeCellValue(item.Client),
                        sanitizeCellValue(item.ActivelistPayrollname),
                        sanitizeCellValue(item.Payrollname),
                        sanitizeCellValue(item.PositionID)
                    ]);
                });

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                loopedList.forEach(row => worksheet.addRow(row));

                await workbook.xlsx.writeBuffer().then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    FileSaver.saveAs(blob, 'unmatched.xlsx');
                });

                return "downloaded";
            } else {
                InfoMessage("No data found !!");
                return null;
            }
        }
    } catch (error) {
        console.error("Error downloading file:", error);
        ErrorMessage("Unable to download");
        return null;
    }
};
